<template>
  <div class="content-wrapper">
    <div class="container">
      <v-row>
        <v-col>
          <div id="modalPrint">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Factura Comercial</h4>
                  <p />
                </div>
                <div id="billdata" class="modal-body">
                  <p />
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="text-center">
                        <h3>FACTURA COMERCIAL / COMERCIAL INVOICE</h3>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr style="border: 1px solid #0f0f0f" />
                    </div>
                    <div class="col-sm-12">
                      FACTURA COMERCIAL NO./ Invoice No.:
                      {{ guia.numfactura }}
                    </div>
                    <div class="col-sm-12">
                      <hr style="border: 1px solid #0f0f0f" />
                    </div>
                    <div class="col-sm-6">
                      <div
                        class="text-center"
                        style="background-color: #000; color: white"
                      >
                        FECHA/ Date:
                      </div>
                      <div class="text-center">
                        {{ new Date(guia.created_at).toLocaleDateString() }}
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div
                        class="text-center"
                        style="background-color: #000; color: white"
                      >
                        NO. DE GUIA/ AWB No.:
                      </div>
                      <div class="text-center">
                        {{ guia.guia_proveedor }}
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="text-center">
                        <hr style="border: 1px solid #0f0f0f" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div>REMITENTE/ Shipper</div>
                      <div>{{ guia.empresa_e }}</div>
                      <div>{{ guia.contacto_e }}</div>
                      <div>{{ guia.direccion1_e }}</div>
                      <div>{{ guia.direccion2_e }}</div>
                      <div>{{ guia.direccion3_e }}</div>
                      <div>{{ guia.ciudad_e }}</div>
                      <div>-</div>
                    </div>
                    <div class="col-sm-6">
                      <div>DESTINATARIO / Consignee</div>
                      <div>{{ guia.empresa_c }}</div>
                      <div>{{ guia.contacto_c }}</div>
                      <div>{{ guia.direccion1_c }}</div>
                      <div>{{ guia.direccion2_c }}</div>
                      <div>{{ guia.direccion3_c }} {{ guia.pais_c }}</div>
                      <div>{{ guia.telefono_c }}</div>
                    </div>
                    <div class="text-center">
                      <hr style="border: 1px solid #0f0f0f" />
                    </div>
                    <div class="col-sm-12">
                      <table class="table" style="font-size: 10px">
                        <thead>
                          <th>UNIDADES /Units</th>
                          <th>
                            DESCRIPCION DEL PRODUCTO /Description of Goods
                          </th>
                          <th>VALOR POR UNIDAD /Unit Value</th>
                          <th>SUB-TOTAL USD$</th>
                        </thead>
                        <tr v-for="item in items" :key="item.id">                          
                          <td>{{ item.cantidad }}</td>
                          <td>{{ item.descripcion }}</td>
                          <td style="text-align: right">
                            {{ item.costo }}
                          </td>
                          <td style="text-align: right">
                            {{ item.total }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-sm-2">Total</div>
                    <div class="col-sm-10">
                      <table class="table">
                        <tbody>
                          <tr>
                            <td style="text-align: right">$ {{ total }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-sm-12">
                      <hr style="border: 1px solid #0f0f0f" />
                    </div>

                    <div class="col-sm-7">
                      INCOTERM:
                      {{
                        guia.pago == "Si"
                          ? " DDP - Delivery Duties Paid"
                          : " DAP - Delivery At Place"
                      }}
                    </div>
                    <div class="col-sm-5">
                      Esta factura es para efectos de tramites aduanales/ This
                      Invoice is for customs clearance purpose
                    </div>
                    <div class="col-sm-12">
                      <hr style="border: 1px solid #0f0f0f" />
                    </div>
                    <div class="col-sm-12">
                      <hr style="border: 1px solid #0f0f0f" />
                    </div>

                    <div class="col-sm-8">
                      Firma y Cargo del Remitente/ Shipper's Signature and Title
                    </div>
                    <div class="col-sm-4" style="text-align: right">
                      Fecha/ Date
                    </div>
                  </div>
                </div>
                <hr class="border" />
                <div class="modal-footer">                                
                    <v-btn @click="imprimirGuia()" color="primary" outlined>Imprimir</v-btn>          
                </div>
              </div>              
            </div>
            <p />
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col class="text-center">
        <v-spacer></v-spacer>
        
      </v-col>
    </v-row>
  </div>
</template>
<script>
import apicon from "../plugins/apicon";
import $ from 'jquery';
//import 'bootstrap/dist/css/bootstrap.css'
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      guia: null,
      total: 0.0,
      items: [],
      isCliente: 1,
    };
  },
  created: function () {},
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillDatosGuia();
    await this.fillDatosItems();
    this.totalizar();
    this.isCliente = localStorage.getItem("cliente");
  },
  methods: {
    fillDatosGuia: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guias/" + this.id)
        .then((result) => {
          this.guia = result;
        });
    },
    fillDatosItems: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "/items/" + this.guia.guia_interna)
        .then((result) => {
          this.items = result;
        });
    },
    totalizar: function () {
      // let sum = 0.00;
      this.total = this.items.reduce(
        (sum, item) => sum + parseFloat(item.total),
        0
      );
    },
    imprimirGuia: function () {
      var mywindow = window.open("", "tracking div", "height=400,width=600");
      mywindow.document.write(
        '<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css"><link rel="stylesheet" href="css/print.css" media="print" /><link rel="stylesheet" href="css/bootstrap-print.min.css" media="print"/></head><body onload="window.print()">'
      );
      mywindow.document.write($("#billdata").html());
      mywindow.document.write("</body></html>");
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function () {
        mywindow.close();
      }, 1000);
    },
  },
};
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css">

</style>
